import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as API from "../api/index";
import * as Yup from "yup";
import { NotificationManager } from "react-notifications";
import { useDataView } from "../../contexts/data.view.context";

import { TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import ConfirmAddDialog from "../util/confirmAddDialog";
import AddFormLayout from "../shared/AddFormLayout";
import SectionGrid from "../shared/SectionGrid";
import { useSectionedForm } from "../shared/useSectionedForm";

const FORM_SECTIONS = [
  {
    id: "details",
    label: "Transfer details",
    fields: [
      "PROJECT_ID",
      "STATE",
      "TRANSFER_TYPE",
      "RETENTION_DAYS",
      "COMMENTS",
    ],
  },
];

const FileTransferForm = () => {
  const validationSchema = Yup.object().shape({
    //TRANSFER_ID: Yup.string().required("Transfer ID is required"),
    PROJECT_ID: Yup.string().required("Project ID is required"),
    STATE: Yup.string().required("State is required"),
    TRANSFER_TYPE: Yup.string().required("Transfer Type is required"),
    RETENTION_DAYS: Yup.string().required("Retention Days is required"),
    COMMENTS: Yup.string().nullable().notRequired().default(""),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { sections, activeId, setActiveId } = useSectionedForm(
    FORM_SECTIONS,
    errors
  );

  const { fetchFileTransfersFromAllEnv } = useDataView();
  const navigate = useNavigate();
  const stateItems = ["Active", "Closed", "Pending", "Locked"];
  const [pendingPayload, setPendingPayload] = useState(null);

  const onSubmit = (data) => {
    data.TRANSFER_ID = "DT_" + data.PROJECT_ID;
    setPendingPayload(data);
  };

  const handleConfirmAdd = () => {
    const data = pendingPayload;
    setPendingPayload(null);
    const resourcePath = "integrations/cfg/transfers";

    API.AddRecord(resourcePath, data).then((response) => {
      if (response.code === 200) {
        const transfer_seq = 0;
        const params = {
          transferID: data.TRANSFER_ID,
          transfer_seq: transfer_seq,
        };
        NotificationManager.success("Record added!", "File Transfer", 10000);
        fetchFileTransfersFromAllEnv();
        navigate("/AddTransferCmd", { state: params });
      } else {
        NotificationManager.error(response.message, "Failed!", 10000);
      }
    });
  };

  return (
    <>
      <AddFormLayout
        title="Add file transfer"
        sections={sections}
        activeSectionId={activeId}
        onSectionChange={setActiveId}
        onBack={() => navigate(-1)}
        primaryLabel="Add"
        onPrimaryClick={handleSubmit(onSubmit)}
      >
        <SectionGrid>
          <TextField
            required
            label="Project ID"
            size="small"
            fullWidth
            {...register("PROJECT_ID")}
            error={!!errors.PROJECT_ID}
            variant="outlined"
          />
          <TextField
            select
            label="State"
            size="small"
            fullWidth
            {...register("STATE")}
            error={!!errors.STATE}
            variant="outlined"
            defaultValue="Active"
          >
            {stateItems.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            required
            label="Transfer Type"
            size="small"
            fullWidth
            {...register("TRANSFER_TYPE")}
            error={!!errors.TRANSFER_TYPE}
            variant="outlined"
          />
          <TextField
            required
            label="Retention Days"
            size="small"
            fullWidth
            {...register("RETENTION_DAYS")}
            error={!!errors.RETENTION_DAYS}
            variant="outlined"
          />
          <SectionGrid.FullWidth>
            <TextField
              required
              label="Comments"
              size="small"
              fullWidth
              {...register("COMMENTS")}
              error={!!errors.COMMENTS}
              variant="outlined"
            />
          </SectionGrid.FullWidth>
        </SectionGrid>
      </AddFormLayout>
      <ConfirmAddDialog
        open={!!pendingPayload}
        onClose={() => setPendingPayload(null)}
        onConfirm={handleConfirmAdd}
        itemLabel="file transfer"
      />
    </>
  );
};

export default FileTransferForm;
